import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DialogPopup from "@_components/DialogPopup/DialogPopup";
import TextfieldInput from "@_components/TextfieldInput/TextfieldInput";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { caseActivityActions } from "@_actions/caseActivity.actions";
import { catchError } from "@_utils/helpers";
import AppSnackbar from "@_components/AppSnackbar/AppSnackbar";
import { useSnackbar } from "@_hooks/useSnackbar";

function AddNotePopup({ open, close, caseId }) {
  const caseActivityReducer = useSelector((state) => state.caseActivityReducer);
  const dispatch = useDispatch();
  const { snackbarProps, showSnackbarError } = useSnackbar();

  const [noteInput, setNoteInput] = useState("");
  const [isClicked, setIsClicked] = useState(false);

  const addNoteStatus = caseActivityReducer?.status?.CASEACTIVITY_ADD;
  const isSubmitting = addNoteStatus === "request";

  const closePopup = useCallback(() => {
    setNoteInput("");
    setIsClicked(false);
    dispatch(caseActivityActions.clearState("CASEACTIVITY_ADD"));
    close();
  }, [close, dispatch]);

  const actionClicked = () => {
    setIsClicked(true);
    const normalizedNote = (noteInput || "").replace(/[\r\n]+$/, "").trim();
    if (!normalizedNote || !caseId) return;
    dispatch(caseActivityActions.saveNote(caseId, normalizedNote));
  };

  useEffect(() => {
    if (addNoteStatus === "success") {
      if (caseId) {
        dispatch(caseActivityActions.getCaseActivities(caseId));
      }
      dispatch(caseActivityActions.clearState("CASEACTIVITY_ADD"));
      setNoteInput("");
      setIsClicked(false);
      close();
    } else if (catchError(addNoteStatus)) {
      showSnackbarError(addNoteStatus);
      dispatch(caseActivityActions.clearState("CASEACTIVITY_ADD"));
      setIsClicked(false);
    }
  }, [addNoteStatus, caseId, close, dispatch, showSnackbarError]);

  return (
    <DialogPopup title={"Add Note"} open={open} onClose={closePopup}>
      <AppSnackbar {...snackbarProps} />
      <TextfieldInput
        data-testid="add-note-input-field"
        label="Note"
        placeholder="Type Note here"
        onChange={(event) => setNoteInput(event?.target?.value || "")}
        multiline
        maxRows={6}
        rows={6}
        name={"add_note_input"}
        inputProps={{ "data-testid": "add-note-input" }}
        value={noteInput}
        error={isClicked && (!noteInput || noteInput.trim().length === 0)}
      ></TextfieldInput>
      <div className="action_container">
        {isSubmitting ? (
          <CircularProgress />
        ) : (
          <>
            <Button
              data-testid="add-note-cancel-btn"
              onClick={closePopup}
              className="btn_cancel"
            >
              Cancel
            </Button>
            <Button
              data-testid="add-note-save-btn"
              onClick={actionClicked}
              autoFocus
              className="btn_confirm"
            >
              Save
            </Button>
          </>
        )}
      </div>
    </DialogPopup>
  );
}

export default AddNotePopup;
